import { useState } from 'react';
import ProductQuantityProvider from './hooks/useProductQuantity';

import { ProductQuantityProps } from './@types/ProductQuantityProps';
import QuantitySelectorContainer from './handles/QuantitySelectorContainer';
import QuantitySelectorTitle from './handles/QuantitySelectorTitle';
import QuantitySelectorStepper from './handles/QuantitySelectorStepper';
import { VtexNumericStepper } from '../../styleguide/VtexNumericStepper.jsx';
import AvailableQuantityContainer from './handles/AvailableQuantityContainer';
import { VtexDropdown } from '../../styleguide/VtexDropdown';

const dropdownOptions = [
	{
		value: 1,
		label: '1',
	},
	{
		value: 2,
		label: '2',
	},
	{
		value: 3,
		label: '3',
	},
	{
		value: 4,
		label: '4',
	},
	{
		value: 5,
		label: '5',
	},
];

const ProductQuantity = (props: ProductQuantityProps) => {
	const [qtd, setQtd] = useState(1);

	return (
		<ProductQuantityProvider {...props}>
			<QuantitySelectorContainer>
				{props.showLabel && <QuantitySelectorTitle />}

				<QuantitySelectorStepper>
					{props.selectorType === 'stepper' && (
						<VtexNumericStepper
							size={props.size}
							value={qtd}
							onChange={(event: { value: number }) => setQtd(event.value)}
						/>
					)}

					{props.selectorType === 'dropdown' && (
						<VtexDropdown
							options={dropdownOptions}
							size={props.size}
							value={qtd}
							onChange={(_: string, v: string) => setQtd(Number(v))}
						/>
					)}
				</QuantitySelectorStepper>

				{props.warningQuantityThreshold > 10 && <AvailableQuantityContainer />}
			</QuantitySelectorContainer>
		</ProductQuantityProvider>
	);
};

export default ProductQuantity;
